import { z } from 'zod'

export const EMAIL_MESSAGES = {
  required: 'Informe o e-mail.',
  invalid: 'Informe um e-mail válido.',
  tooLong: 'O e-mail pode ter no máximo 254 caracteres.',
} as const

/** E-mail normalizado: sem espaços nas pontas e em minúsculas. */
export const emailSchema = z
  .string({ error: EMAIL_MESSAGES.required })
  .trim()
  .toLowerCase()
  .min(1, { error: EMAIL_MESSAGES.required })
  .max(254, { error: EMAIL_MESSAGES.tooLong })
  .pipe(z.email({ error: EMAIL_MESSAGES.invalid }))

export const isoDateTimeSchema = z.iso.datetime({ offset: true })

export const PaginationQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(20),
  search: z
    .string()
    .trim()
    .max(120, { error: 'A busca pode ter no máximo 120 caracteres.' })
    .optional()
    .transform((value) => (value ? value : undefined)),
})
export type PaginationQuery = z.infer<typeof PaginationQuerySchema>

export interface Paginated<T> {
  items: T[]
  page: number
  pageSize: number
  total: number
}

export function paginatedSchema<T extends z.ZodType>(item: T) {
  return z.object({
    items: z.array(item),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1),
    total: z.number().int().min(0),
  })
}

/** Parâmetro de query string vazio (`?status=`) conta como ausente. Use com `z.preprocess`. */
export function blankToUndefined(value: unknown): unknown {
  return typeof value === 'string' && value.trim() === '' ? undefined : value
}

/** Booleano de query string: `true`/`false` (também `1`/`0`). */
export const queryBooleanSchema = z
  .enum(['true', 'false', '1', '0'], { error: 'Use true ou false.' })
  .transform((value) => value === 'true' || value === '1')
